/*
|--------------------------------------------------------------------------
| Methoden, welche mit Arrays arbeiten oder auf Arrays prüfen
|--------------------------------------------------------------------------
|
 */

/**
 * Check of es sich um ein Array handelt
 * @param  mixed  arr
 * @return {Boolean}
 */
export function isArray(arr) {
	let toString = {}.toString;

	return Array.isArray(arr) || (toString.call(arr) == '[object Array]');
}

/**
 * Liefert die in beiden Arrays enthaltenen Elemente zurück
 * @param  Array a
 * @param  Array b
 * @return Array
 */
export function intersect_safe(a, b)
{
  let ai = 0;
  let bi = 0;
  let result = [];

  while( ai < a.length && bi < b.length ){
     if      (a[ai] < b[bi] ){ ai++; }
     else if (a[ai] > b[bi] ){ bi++; }
     else /* they're equal */
     {
       result.push(a[ai]);
       ai++;
       bi++;
     }
  }

  return result;
}

/**
 * Check, ob Arrays gleich sind
 * @param  Array a
 * @param  Array b
 * @return Boolean
 */
export function aEqual(a, b) {
    if (a === b) {
        return true;
    }

    if (a == null || b == null) {
        return false;
    }

    if (a.length != b.length) {
        return false;
    }

    // If you don't care about the order of the elements inside
    // the array, you should sort both arrays here.

    for (var i = 0; i < a.length; ++i) {
        if (a[i] !== b[i]) return false;
    }
    return true;
}

/**
 * Prüft, ob ein Array, welches Zahlen enthält, Lücken aufweißt
 * @param  Array array
 * @return boolean
 */
export function aHasGaps(array) {
    if (!Array.isArray(array) || array.length === 0) {
        return false;
    }
    array.sort((a, b) => a - b);

    return array[0] + array.length !== array[array.length - 1] + 1;
}

/**
 * Prüft, ob ein Array, welches Zahlen enthält, Lücken aufweißt
 * @param  Array array
 * @return boolean
 */
export function getElementsAfterGap(array) {
    if (array.length === 0 || !aHasGaps(array)) {
        return [];
    }

    array.sort((a, b) => a - b);
    const { length } = array;

    for (let i = 0; i < length; i++) {
        if (array[i] !== array[i + 1] - 1) {
            return array.slice(i + 1);
        }
    }

    return [];
}

/**
 * Mehrdimensionales Array reduzieren
 * @param  Array arr
 * @return Array
 */
export function flatten(arr){
    return arr.reduce(
      (acc, val) => acc.concat(
        Array.isArray(val) ? flatten(val) : val
      ),
      []
    );
}

/**
 * This is how it's usually done. The idea is to place each element in a hashtable and then check
 * for its presence instantly. This gives us linear time, but has at least two drawbacks:
 *
 * - since hash keys can only be strings in Javascript, this code doesn't distinguish
 * numbers and "numeric strings". That is, uniq([1,"1"]) will return just [1]
 *
 * - for the same reason, all objects will be considered equal:
 * uniq([{foo:1},{foo:2}]) will return just [{foo:1}].
 *
 * @param  {[type]} a [description]
 * @return {[type]}   [description]
 */
export function uniq(a) {
    var seen = {};
    return a.filter(function(item) {
        return seen.hasOwnProperty(item) ? false : (seen[item] = true);
    });
}

/**
 * Checkt ob jedes Element eines Arrays in einem anderen enthalten ist
 *
 * @param  Array, welches enthalten sein soll needle
 * @param  Array, welches durchsucht wird haystack
 * @return Boolean
 */
export function containsArray(needle, haystack){
    if(!needle.length)
        return false;

    if(!haystack.length)
        return false;

    for(var i = 0; i < needle.length; i++){
        if(haystack.indexOf(needle[i]) === -1)
            return false;
    }

    return true;
}

/**
 * Return Elements not contained in arr
 * @param  array arr
 * @return array
 */
export function diff(arr) {
    return this.filter((index) => {
        return arr.indexOf(index) < 0;
    });
};

/**
 * Return Elements not contained in arr
 * @param  array arr
 * @return array
 */
export function range(from, to) {
    let arr = [];

    for(from; from <= to; from++){
        arr.push(from);
    }

    return arr;
};
